import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsletterCategoryForm from '../../../components/forms/NewsletterCategoryForm';
import { useNewsletterCategoryApi } from '../../../hooks/useNewsletterCategoryApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { NewsletterCategoryDTO } from '../../../services/apiClient';

const NewsletterCategoryCreate: React.FC = () => {
  const { create, isLoading } = useNewsletterCategoryApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Newsletter Categories', href: '/admin/newslettercategories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: NewsletterCategoryDTO) => {
    try {
      await create(data);
      navigate('/admin/newslettercategories');
    } catch (error) {
      console.error('Error creating NewsletterCategory:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newslettercategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.NewsletterCategory.Edit'
    >
        <NewsletterCategoryForm
          initialValues={{} as NewsletterCategoryDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/newslettercategories')}
        />
    </AdminLayout>
  );
};

export default NewsletterCategoryCreate;